<template>
<div>
    <Header></Header>
    <header class="py-3 mb-4 border-bottom">
        <div class="container d-flex flex-wrap justify-content-center">
            <a class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">
                <button @click="updateFilter('All')" :class="{ 'btn-outline-success': filterStatus === 'All', 'btn btn-outline-success': filterStatus === 'All' }" class="btn mx-2">All</button>
                <button @click="updateFilter('Cash')" :class="{ 'btn-outline-success': filterStatus === 'Cash', 'btn btn-outline-success': filterStatus === 'Cash' }" class="btn mx-2">Cash</button>
                <button @click="updateFilter('IBFT')" :class="{ 'btn-outline-success': filterStatus === 'IBFT', 'btn btn-outline-success': filterStatus === 'IBFT' }" class="btn">IBFT</button>
                <div class="w-100 align-inputs-range">
                    <div class="searchbar col position-relative d-flex align-items-center">
                        <date-range-picker ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }" :showWeekNumbers="true" :showDropdowns="true" :autoApply="true" v-model="paymentDueDateFilter" class="search-input" control-container-class="d-flex align-items-center gap-3" opens="left" :ranges="dateRangePresets" :maxDate="new Date()">
                            <template v-slot:input="picker" style="min-width: 350px;">
                                <i class="fa-solid fa-calendar text-muted"></i>
                                <span class="text-sm" v-if="picker.startDate || picker.endDate">
                                    {{ formattedDate(picker.startDate) }} -
                                    {{ formattedDate(picker.endDate) }}
                                </span>
                                <span class="text-muted text-sm" v-else>
                                    Search by Date
                                </span>
                                <i @click="resetDueDateFilter" class="fa fa-times ms-auto text-muted cursor-pointer" v-if="picker.startDate || picker.endDate"></i>
                                <i v-else class="fa fa-caret-down ms-auto text-muted"></i>
                            </template>
                        </date-range-picker>
                    </div>
                </div>
                <button @click="updateDateRange" :disabled="loading" class="ms-4 filter-btn">
                    <i class="fa fa-search"></i>
                    Search
                </button>
                <svg class="bi me-2" width="40" height="32">
                    <use xlink:href="#bootstrap" />
                </svg>
                <span class="fs-4"></span>
            </a>

            <form class="col-12 col-lg-auto mb-3 mb-lg-0">
                <input type="search" class="form-control" placeholder="Search..." aria-label="Search" v-model="searchString">
            </form>
        </div>
    </header>
    <div class="container">
        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
            <b-spinner></b-spinner> Loading...
        </div>
        <table v-else-if="paymentList && paymentList.length > 0" class="table table-striped">
            <thead>
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Posting Date</th>
                    <th>Mode</th>
                    <th>Total Amount</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(payment,index) in paymentList" :key="payment.name" @click="handleAttachments(payment)" class="cursor-pointer">
                    <td><strong>{{ index + 1 }}</strong></td>
                    <td><strong>{{ payment.name }}</strong></td>
                    <td>{{ payment.party_name }}</td>
                    <td>{{ formattedDate(payment.posting_date) }}</td>
                    <td>{{ payment.mode_of_payment }}</td>
                    <td>{{ payment.total_allocated_amount }}</td>
                    <td>
                        <div class="d-flex">
                            <button type="button" class="btn btn-success"><i class="fa-solid fa-check"></i></button>
                            <button type="button" class="btn btn-danger ms-3">
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <ViewAttachmentModal :paymentId="paymentId" :showPaymentAttachments="showPaymentAttachments" @updatePaymentAttachmentsModal="updatePaymentAttachmentsModal" />
    <Footer></Footer>
</div>
</template>

<script>
import Header from '../components/Layout/Header.vue';
import Footer from './Layout/Footer.vue';
import DateRangePicker from "vue2-daterange-picker";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
    formattedDate
} from './InvoiceList.vue';
import ViewAttachmentModal from './Layout/ViewAttachmentModal.vue';
import {
    mapState
} from 'vuex';
export default {
    name: 'PaymentList',
    data() {
        return {
            loading: false,
            paymentList: [],
            searchString: null,
            paymentId: null,
            showPaymentAttachments: false,
            filterStatus: "All",
            paymentDueDateFilter: {
                startDate: null,
                endDate: null,
            },
        };
    },
    components: {
        Header,
        Footer,
        ViewAttachmentModal,
        DateRangePicker
    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"]),
        dateRangePresets() {
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            let yesterday = new Date();
            yesterday.setDate(today.getDate() - 1);
            yesterday.setHours(0, 0, 0, 0);
            let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            return {
                Today: [today, today],
                Yesterday: [yesterday, yesterday],
                "This month": [thisMonthStart, thisMonthEnd],
                "Last month": [
                    new Date(today.getFullYear(), today.getMonth() - 1, 1),
                    new Date(today.getFullYear(), today.getMonth(), 0),
                ],
                "Last 3 months": [
                    new Date(today.getFullYear(), today.getMonth() - 3, 1),
                    new Date(today.getFullYear(), today.getMonth(), 0),
                ],
                "Last 6 months": [
                    new Date(today.getFullYear(), today.getMonth() - 6, 1),
                    new Date(today.getFullYear(), today.getMonth(), 0),
                ],
                "This year": [
                    new Date(today.getFullYear(), 0, 1),
                    new Date(today.getFullYear(), 11, 31),
                ],
                "Last year": [
                    new Date(today.getFullYear() - 1, 0, 1),
                    new Date(today.getFullYear() - 1, 11, 31),
                ],
            };
        },
    },
    methods: {
        // async fetchPaymentList() {
        //     try {
        //         this.loading = true;
        //         let apiUrl = this.erp_api_url + 'api/resource/Payment%20Entry?limit_start=0&limit_page_length=600&fields=["*"]&order_by=creation desc';

        //         if (this.filterStatus !== 'All') {
        //             const filter = `[["Payment Entry", "mode_of_payment", "=", "${this.filterStatus}"]]`;
        //             apiUrl += `&filters=${filter}`;
        //         }

        //         if (this.paymentDueDateFilter.startDate && this.paymentDueDateFilter.endDate) {
        //             const startTimestamp = new Date(this.paymentDueDateFilter.startDate).toISOString();
        //             const endTimestamp = new Date(this.paymentDueDateFilter.endDate).toISOString();

        //             const dateRangeFilter = `[["Payment Entry", "posting_date", ">=", "${startTimestamp}"], ["Payment Entry", "posting_date", "<=", "${endTimestamp}"]]`;
        //             apiUrl += `&filters=${dateRangeFilter}`;
        //         }

        //         const response = await fetch(apiUrl, {
        //             method: 'GET',
        //             headers: {
        //                 'Authorization': 'token f5eed781437effa:0952d24c958d451',
        //             },
        //         });

        //         const payments = await response.json();
        //         this.paymentList = payments.data;
        //     } catch (error) {
        //         console.error('Error fetching leads:', error);
        //     } finally {
        //         this.loading = false;
        //     }
        // },
        async fetchPaymentList() {
            try {
                this.loading = true;
                let apiUrl = this.erp_api_url + 'api/resource/Payment%20Entry?limit_start=0&limit_page_length=600&fields=["*"]&order_by=creation desc';
                if (this.filterStatus !== 'All') {
                    const filter = `[["Payment Entry", "mode_of_payment", "=", "${this.filterStatus}"]]`;
                    apiUrl += `&filters=${filter}`;
                }
                if (this.paymentDueDateFilter.startDate && this.paymentDueDateFilter.endDate) {
                    const startTimestamp = new Date(this.paymentDueDateFilter.startDate).toISOString();
                    const endTimestamp = new Date(this.paymentDueDateFilter.endDate).toISOString();

                    const dateRangeFilter = `[["Payment Entry", "creation", ">=", "${startTimestamp}"], ["Payment Entry", "creation", "<=", "${endTimestamp}"]]`;
                    apiUrl += `&filters=${dateRangeFilter}`;
                }

                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });

                const payments = await response.json();
                this.paymentList = payments.data;
            } catch (error) {
                console.error('Error fetching payments:', error);
            } finally {
                this.loading = false;
            }
        },

        formattedDate(dateString) {
            const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
            return formattedDate;
        },
        formatDate(date) {
            return toShortDateString(date);
        },
        handleAttachments(payment) {
            if (payment.mode_of_payment !== 'Cash') {
                this.showPaymentAttachments = true;
                this.paymentId = payment.name;
                $('#viewAttachment').modal('show');
            }
        },
        updatePaymentAttachmentsModal() {
            this.showPaymentAttachments = !this.showPaymentAttachments;
            $('#viewAttachment').modal('hide');
        },
        updateFilter(status) {
            this.filterStatus = status;
            this.fetchPaymentList();
        },
        updateDateRange() {
            if (this.paymentDueDateFilter.startDate || this.paymentDueDateFilter.endDate) {
                this.fetchPaymentList();
            }
        },
        resetDueDateFilter(e) {
            e.stopPropagation();
            this.paymentDueDateFilter = {
                startDate: null,
                endDate: null,
            };
        },
    },
    created() {
        this.fetchPaymentList();
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.search-input {
    background: #ffffff;
    border: 1px solid #dcdcdc;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    width: 100%;
    text-align: left;
    /* margin-bottom: 1rem; */
    /* font-weight: 500; */
    color: #000000;
    font-size: 1rem;
    column-gap: 0.75rem;
    position: relative;
    outline: none;

    /* transition: transform 0.3s; */
}

.buttons-container .searchbar {
    flex-grow: 1;
}

.align-inputs-range {
    margin-left: 300px;
}

.filter-btn {
    background: #ffffff;
    border: 1px solid #104ee0;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    text-decoration: none;
    color: #000000;
    display: flex;
    -moz-column-gap: 0.5rem;
    column-gap: 0.5rem;
    align-items: center;
    transition: all 0.3s ease;
}

.filter-btn:hover {
    box-shadow: (3px 5px 6px rgba(197, 197, 197, 0.3));
}
</style>
